export default "__VITE_PUBLIC_ASSET__5ee2f7ce__"